import { render, staticRenderFns } from "./DataIngestionExecutions.vue?vue&type=template&id=25988e24&"
import script from "./DataIngestionExecutions.vue?vue&type=script&lang=ts&"
export * from "./DataIngestionExecutions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports